import React from 'react';

const ShadowContainer = ({ Image, width, height, imageStyle }) => {
  const shadowOffset = 20;

  return (
    <div style={{ ...styles.container, width: `${width}px`, height: `${height}px` }}>
      <div
        style={{
          ...styles.shadowYellow,
          width: `${width}px`,
          height: `${height}px`,
          top: shadowOffset,
          left: shadowOffset,
        }}
      ></div>
      <div
        style={{
          ...styles.shadowBlue,
          width: `${width}px`,
          height: `${height}px`,
          top: shadowOffset * 2,
          left: shadowOffset * 2,
        }}
      ></div>
      <img
        src={Image}
        alt=""
        style={{
          ...styles.image,
          width: `${width}px`,
          height: `${height}px`,
          ...imageStyle, 
        }}
      />
    </div>
  );
};

const styles = {
  container: {
    position: 'relative',
    display: 'inline-block',
  },
  shadowYellow: {
    position: 'absolute',
    backgroundColor: 'rgba(211, 226, 5, 1)',
    borderRadius: '24px',
    zIndex: 1,
  },
  shadowBlue: {
    position: 'absolute',
    backgroundColor: 'rgba(25, 118, 210, 1)',
    borderRadius: '24px',
    zIndex: 0,
    border: '1px solid rgba(211, 226, 5, 1)',
  },
  image: {
    position: 'relative',
    objectFit: 'cover',
    zIndex: 2,
    borderRadius: '24px',
    border: '1px solid rgba(211, 226, 5, 1)',
  },
};

export default ShadowContainer;
